import Button from "../../../components/common/Button";
import jwt_decode from "jwt-decode";
import Confetti from "react-confetti";
import ReactPlayer from "react-player";
import feedbackTitle from "../../../assets/img/bg/feeback_title.png";
import feedback01 from "../../../assets/img/icons/feedback_01.png";
import feedback02 from "../../../assets/img/icons/feedback_02.png";
import feedback03 from "../../../assets/img/icons/feedback_03.png";
import feedback04 from "../../../assets/img/icons/feedback_04.png";
import feedback05 from "../../../assets/img/icons/feedback_05.png";
import feedbackBar from "../../../assets/img/bg/feedback_bar.png";
import feedbackMudraKosh from "../../../assets/img/icons/mudrakosh.png";
import bgBorder from "../../../assets/img/bg/border.svg";
import kalashIcon from "../../../assets/img/icons/kalash.png";
import facebook48 from "../../../assets/img/icons/facebook-48.png";
import whatsapp48 from "../../../assets/img/icons/whatsapp-48.png";
import email48 from "../../../assets/img/icons/icons-gmail.png";
import instagram48 from "../../../assets/img/icons/instagram-48.png";
import twitter48 from "../../../assets/img/icons/twitter-48.png";
import linkedin48 from "../../../assets/img/icons/linkedin-48.png";
import successCheck from "../../../svg/successCheck.svg";
import "../../../assets/font_icons/style.css";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { SERVER_URL } from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import { OnAboutSubmit } from "../../venderFlow/profileSetup/queries";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { removeDuplicates } from "../../../utils";
import { feedbackTextValues } from "../../../constants";
import { submitFeedback } from "../../../store/apiCalls/profilesetup";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import "../../../assets/scss/components/_modalGlobal.scss";

const initialState = {
  showFeedbackModal: false,
  skipModal: false,
  congratsModal: false,
  referModal: false,
  congratsPreview: false,
};
const FeedbackFlow = ({
  modalStat = {},
  profileData = {},
  code = "",
  handleModalClose = () => {},
  // onProfilePublish = () => undefined
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [suggestion, setSuggestion] = useState("");
  const dataPayload = useSelector((state) => state?.LoginReducer?.user);
  const { id } = jwt_decode(localStorage.vendorToken || "");
  const [feedbackScore, setFeedbackScore] = useState(null);
  const headers = { Authorization: `Bearer ${localStorage.vendorToken}` };
  const publishSuccessHandler = (_success) => {
    if (_success?.status === 200) {
      handleModalClose({ ...initialState, congratsModal: true });
      dataPayload.isSetupProfile = true;
      // onProfilePublish();
      // navigate('/')
    } else {
      toast.error(_success?.data?.error);
      handleModalClose(initialState);
    }

    dispatch({
      type: "SET_LOADER",
      payload: false,
    });
  };

  const { mutate: PublishProfile } = OnAboutSubmit(publishSuccessHandler);

  const handlePublishProfile = () => {
    dispatch({
      type: "SET_LOADER",
      payload: true,
    });
    const queryParams = {
      isSetupProfile: true,
      publishProfile: true,
      vendoreId: id,
      headers: { ...headers, "Content-Type": "application/json" },
    };
    PublishProfile(queryParams);
  };

  const handleChange = (e) => {
    setFeedbackScore(e.target.value);
  };

  const handleRedirectVideo = (e) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    localStorage.clear();
    // dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
    window.navigation.navigate(SERVER_URL + "browse");
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const queryParams = {
      params: { id: id },
      data: {
        vendorId: id,
        rating: parseInt(feedbackScore),
        feedbackText: suggestion,
      },
      headers,
    };

    const resPayload = await submitFeedback(queryParams);
    if (resPayload.data.success) {
      handleModalClose(
        { ...modalStat, showFeedbackModal: false, congratsPreview: true },
        true
      );
    } else {
      toast.error(resPayload.data.error);
    }
  };

  const handleCongratsModalClose = (publish = false) => {
    if (publish) {
      handlePublishProfile();
    } else {
      handleModalClose({ ...initialState, referModal: !publish });
    }
  };

  const handleReferModalClose = (publish = false) => {
    if (publish) {
      handlePublishProfile();
    } else {
      handleModalClose(initialState);
    }
  };

  const handleSkipModalClose = (publish = false) => {
    if (publish) {
      handlePublishProfile();
    } else {
      handleModalClose({ ...initialState, showFeedbackModal: !publish });
    }
  };

  const handleCodeCopy = (e) => {
    window.navigator.clipboard.writeText(code);
    e.target.textContent = "Copied";
    e.target.style.setProperty("color", "green");
  };

  const handleClose = () => {
    handleModalClose(initialState);
  };

  const handleSkipModalOpen = (e) => {
    e.preventDefault();
    handleModalClose({
      ...modalStat,
      showFeedbackModal: false,
      skipModal: true,
    });
  };

  const handleRedirect = (e) => {
    e.preventDefault();
    localStorage.clear();
    // dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
    window.navigation.navigate(SERVER_URL);
  };

  const shareUrl = window.location.origin;
  // const title =
  //   "Your friend has sent you a referral code. Use the referral code to Register on Vikramshila and earn 250 Mudras (INR) as welcome bonus. You can use the Mudras to publish your research paper with us. Please use the code: " +
  //   code;

  const title = 
  `I have just signed up as a researcher with Vikramshila Education. It is an Indian Open Access Platform for Research Publishing. I really liked their mission to create multiple digital platforms to help disseminate research, primarily from the developing world. I would like you to be a part of this movement. 
  
  Use the referral code ${code} to register on the "https://vikramshilaedu.in/" and be a part of the largest database of research professionals. You will earn 250 mudras as welcome bonus (INR 250), which you can use to publish your own research paper. 
  
  "https://vikramshilaedu.in/registration"`

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Modal
        show={modalStat.showFeedbackModal}
        className="modal"
        id="feedbackModal"
        centered
        tabIndex={-1}
      >
        <form onSubmit={(e) => handleFormSubmit(e)}>
          <div>
            <div className="">
              <Modal.Header closeButton></Modal.Header>
              <div className="modal-header pb-0 pt-0">
                <span className="smallSubText">
                  Before you publish your profile
                </span>
                <h5 className="modal-title">WE WANT TO KNOW HOW WE DID</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={(e) => handleClose()}
                  // aria-label="Close"
                />
              </div>
              <div className="modal-body pt-0 pb-0">
                <div className="px-2 feedbackContent">
                  <p>Feedback will help us improve your experience</p>
                  <div className="feedbackSmiley mt-4 mb-3">
                    <div className="feedbackTitle">
                      <img src={feedbackTitle} alt="#" />
                    </div>
                    <ul>
                      <li>
                        <label className="smileyWrap">
                          <input
                            value={1}
                            type="radio"
                            name="rating"
                            onChange={handleChange}
                            required
                          />
                          <span>
                            <img src={feedback01} alt="#" />
                          </span>
                        </label>
                      </li>
                      <li>
                        <label className="smileyWrap">
                          <input
                            value={2}
                            type="radio"
                            name="rating"
                            onChange={handleChange}
                            required
                          />
                          <span>
                            <img src={feedback02} alt="#" />
                          </span>
                        </label>
                      </li>
                      <li>
                        <label className="smileyWrap">
                          <input
                            value={3}
                            type="radio"
                            name="rating"
                            onChange={handleChange}
                            required
                          />
                          <span>
                            <img src={feedback03} alt="#" />
                          </span>
                        </label>
                      </li>
                      <li>
                        <label className="smileyWrap">
                          <input
                            value={4}
                            type="radio"
                            name="rating"
                            onChange={handleChange}
                            required
                          />
                          <span>
                            <img src={feedback04} alt="#" />
                          </span>
                        </label>
                      </li>
                      <li>
                        <label className="smileyWrap">
                          <input
                            value={5}
                            type="radio"
                            name="rating"
                            onChange={handleChange}
                            required
                          />
                          <span>
                            <img src={feedback05} alt="#" />
                          </span>
                        </label>
                      </li>
                    </ul>
                    <div className="feedbackBar">
                      <img src={feedbackBar} alt="#" />
                    </div>
                  </div>
                  <div>
                    <label className="labelForm">
                    <div dangerouslySetInnerHTML={{__html: feedbackTextValues[feedbackScore]}} />
                    </label>
                    <div>
                      {feedbackScore && (
                        <textarea
                          value={suggestion}
                          onChange={(e) => setSuggestion(e.target.value)}
                          className="fieldForm"
                          name="suggestion"
                          placeholder="We are listening intently..."
                          required
                        ></textarea>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  style={{ fontSize: '22px' }}
                  className="button button-primary w-50"
                  type="submit"
                  disabled={!feedbackScore && !suggestion}
                  onClick={(e) => handleFormSubmit(e)}
                >
                  SUBMIT
                </button>
                <div className="feedbackReward">
                  <p>
                    Share your feedback and get <b>500 Mudras!</b>
                  </p>
                </div>
                <a
                  className="btn-skip grey"
                  href="#"
                  onClick={(e) => handleSkipModalOpen(e)}
                >
                  Skip
                </a>
              </div>
            </div>
          </div>
        </form>
      </Modal>

      {modalStat.skipModal && (
        <Modal show={modalStat.skipModal} id="skipModal" centered tabIndex={-1}>
          <div>
            <div className="">
              <div className="modal-header">
                <h5 className="modal-title">
                  If you skip now, you will miss the chance to earn 500 Mudras
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={(e) => handleClose()}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body pt-0 pb-2">
                <div className="px-2 text-center">
                  <p>You can use Mudras to get discounts on the website</p>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="button"
                  onClick={(e) => handleSkipModalClose(true)}
                >
                  Publish My Profile
                </button>
                <button
                  type="button"
                  className="button button-primary ms-2"
                  onClick={(e) => handleSkipModalClose(false)}
                >
                  I want 500 Mudras
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {modalStat.congratsPreview && (
        <Modal
          show={modalStat.congratsPreview}
          id="congratsModal"
          tabIndex={-1}
          dialogClassName="congrats-modal-dialog"
        >
          <Confetti width={"450px"} height={"300px"} numberOfPieces={100} />
          <div>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title bigText">CONGRATULATIONS</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={(e) => handleClose()}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body pt-0 pb-0">
                <div className="px-2 text-center">
                  <div className="mudrakoshBox">
                    <p>500 Mudras DEPOSITED</p>
                    <span>
                      <img src={feedbackMudraKosh} alt="#" />
                    </span>
                  </div>
                  <div className="divideWrap">
                    <img src={bgBorder} alt="#" />
                  </div>
                  <p>Would You like to earn 250 mudras more? </p>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="button"
                  onClick={(e) => handleCongratsModalClose(false)}
                >
                  Refer and Earn
                </button>
                <button
                  className="button button-primary ms-2"
                  onClick={(e) => handleCongratsModalClose(true)}
                >
                  No, Publish my Profile
                </button>
                <div className="rewardNote">
                  <small>
                    You will be able to check your reward in the “My Income”
                    section
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {modalStat.referModal && (
        <Modal show={modalStat.referModal} id="referModal" tabIndex={-1}>
          <div>
            <div className="modal-content referContent">
              <div className="modal-header pb-0">
                <h5 className="modal-title bigText">Refer and Earn</h5>
                <p className="bigSubText">Invite 5 friends to register</p>
                <div className="mudraCount">
                  <div>
                    <span>
                      <b>Earn</b>
                      <br />
                      250 Mudras
                    </span>
                    <b>
                      <img src={kalashIcon} alt="#" />
                    </b>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={(e) => handleClose()}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body pt-0 pb-0">
                <div className="px-2 text-center shareModal">
                  <div className="referStep">
                    <ul>
                      <li>
                        <span>
                          <b className="icon-persons" />
                        </span>
                        Invite 5 friends to register
                      </li>
                      <li>
                        <span>
                          <b className="icon-register" />
                        </span>
                        Your friends register
                      </li>
                      <li>
                        <span>
                          <b className="icon-wallet" />
                        </span>
                        You receive 250 Mudras{" "}
                      </li>
                    </ul>
                  </div>
                  <p className="refer-earn">Your friends also receive 250 Mudras each as joining bonus after registration</p>
                  <div className="socialShare">
                    <small>Invite via</small>
                    <ul>
                      <li>
                        <EmailShareButton
                          separator=" "
                          subject="Refer and Earn"
                          body={title}
                          // url={shareUrl}
                          url=" "
                          shareUrl={title}
                        >
                          <img src={email48} alt="#" />
                        </EmailShareButton>
                      </li>
                      <li>
                        <WhatsappShareButton
                          url={shareUrl}
                          title={title}
                          separator=" "
                          className="Demo__some-network__share-button"
                        >
                          <img src={whatsapp48} alt="#" />
                        </WhatsappShareButton>
                      </li>
                      <li>
                        <TwitterShareButton
                          url={shareUrl}
                          separator=" "
                          title={title}
                          className="Demo__some-network__share-button"
                        >
                          <img src={twitter48} alt="#" />
                        </TwitterShareButton>
                      </li>
                    </ul>
                  </div>
                  <div className="divideLine">
                    <b>or</b>
                  </div>
                  <div className="codeBelow ">
                    <small>Refer using your unique code</small>
                    <div className="codeWrap">
                      <p id="#code">{code}</p>
                      <p onClick={handleCodeCopy}>
                        <b className="icon-copy" />
                        &nbsp;&nbsp; Copy Code
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer pt-0">
                <button
                  onClick={(e) => handleReferModalClose(false)}
                  className="button"
                >
                  I’ll do it later
                </button>
                <button
                  onClick={(e) => handleReferModalClose(true)}
                  className="button button-primary ms-2"
                >
                  Publish Profile
                </button>
                <div className="rewardNote">
                  <small>
                    Receiving 250 Mudras is conditional to 5 friends registering
                    with us
                    <br />
                    You will be able to check your reward in the “My Income”
                    section
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {modalStat.unPublish && (
        <Modal
          show={modalStat.unPublish}
          dialogClassName="founder-message unpublish-modal"
          tabIndex={-1}
          centered
        >
          <Modal.Header className="justify-content-center pb-1 px-0 pt-0">
            <Modal.Title className="mt-5">
              <div className="mb-3 title">
                Your profile can not be published right now
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={(e) => handleClose()}
                aria-label="Close"
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="text-center content label-info color-black"
              dangerouslySetInnerHTML={{
                __html:
                  "Your request for service needs to get approved by the admin first",
              }}
            />
          </Modal.Body>
          <Modal.Footer className="justify-content-center mt-3 d-grid">
            <Button title="Okay" handleClick={handleClose} type="button" />
          </Modal.Footer>
        </Modal>
      )}

      {modalStat.congratsModal && (
        <Modal
        show={modalStat.congratsModal}
        className="founder-message success-modal"
        id="successMsg"
        tabIndex={-1}
        >
          <Confetti width={"400px"} height={"300px"} numberOfPieces={100} />
          <Modal.Header className="justify-content-center pb-1 px-0 pt-0">
            <div className="header-before">
              <img src={successCheck} alt="success" />
            </div>
            <Modal.Title className="mt-5">
              <div className="mb-1">CONGRATULATIONS!</div>
            </Modal.Title>
        {/* <button
          type="button"
          className="btn-close"
          onClick={(e) => handleClose()}
          aria-label="Close"
        /> */}
          </Modal.Header>
          <div
            className="text-center label-info color-black"
            dangerouslySetInnerHTML={{
              __html:
                "You are now a registered service provider with us.<br /> <p>Please check your email for more details and do <br /> not forget to add us to your safe senders list.</p>"
            }}
          />
          <Modal.Footer className="succes-msg justify-content-center mt-3 d-grid" style={{zIndex: 9999}}>
              <Button 
                handleClick={(e) => handleRedirectVideo(e)}
                title="MESSAGE FROM THE FOUNDER"
                type="button"
              />
            <div className="text-center">
              <Link
                to="/vendordashboard"
                onClick={(e) => handleRedirect(e)}
                className="link text-decoration-none f-700"
              >
                HOME
              </Link>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default FeedbackFlow;
